import React, { useEffect, useState } from "react";
import CommonTable, { createRowCellContentInner } from "../../../common/table";
// import { useIntl } from "react-intl";
import { GroupSystemRole, RequestRole } from "../../../../types/brm/request-types";
import "./styles.less";
import { Typography } from "@mui/material";
import { useIntl } from "react-intl";

const getCellValue = (row, column): string => {
    switch (column.id) {
        default:
            return `${row[column.id] ?? ""}`;
    }
};

type SystemsGroup = {
    id: string;
    description: string;
    systems: { id: string }[];
};

type AddRoleToRequestDialogTableProps = {
    roles: GroupSystemRole[];
    currentSystem: string;
    setCurrentSystem: (system: string) => void;
    isSelectGroupDisabled: boolean;
    getGroupSystems: () => Promise<SystemsGroup[]>;
    selectedRoles: string[];
    setSelectedRoles: (value: string[]) => void;
    searchString: string;
    setSearchString: (value: string) => void;
};

const AddRoleToRequestDialogTable: React.FC<AddRoleToRequestDialogTableProps> = ({
    roles,
    currentSystem,
    setCurrentSystem,
    getGroupSystems,
    selectedRoles,
    setSelectedRoles,
    searchString,
    setSearchString,
    isSelectGroupDisabled,
}) => {
    // const intl = useIntl();
    // const options = getGroupSystems().map((system) => {
    //     return { value: system.group_id, title: system.group_id };
    // });
    const intl = useIntl();
    const [options, setOptions] = useState<{ value: string; title: string }[]>([]);

    useEffect(() => {
        getGroupSystems().then((systems) => {
            const formattedOptions = systems.map((system) => ({ value: system.id, title: system.id }));
            setOptions(formattedOptions);
            // if (formattedOptions.length > 0) {
            //     setCurrentSystem(formattedOptions[0].value);
            // }
        });
    }, [getGroupSystems]);
    const columns = [
        {
            id: "select",
            type: "select",
        },
        {
            id: "role",
            title: intl.formatMessage({ id: "add-role-to-request-dialog-table-column.role" }),
            type: "string",
        },
        {
            id: "roleType",
            title: intl.formatMessage({ id: "add-role-to-request-dialog-table-column.role-type" }),
            type: "string",
        },
        // {
        //     id: "systemId",
        //     title: "Система",
        //     type: "string",
        // },
        {
            id: "description",
            title: intl.formatMessage({ id: "add-role-to-request-dialog-table-column.description" }),
            type: "string",
        },
    ];

    const toolbarActions = [
        {
            id: "select",
            type: "select",
            position: "begin",
            options: options,
            value: currentSystem,
            disabled: isSelectGroupDisabled,
            callback: setCurrentSystem,
        },
        {
            id: "search",
            type: "search",
            position: "begin",
            value: searchString,
            callback: setSearchString,
        },
    ];

    const createRowCellContent = (row, column, selected, onSelect, getCellValue) => {
        switch (column.id) {
            case "roleType": {
                return <Typography>{`${row.isComplex ? intl.formatMessage({ id: "common.group-role-text" }) : intl.formatMessage({ id: "common.single-role-text" })}`}</Typography>;
            }
            default:
                return createRowCellContentInner(row, column, selected, onSelect, getCellValue);
        }
    };
    const handleSelectRow = (row: RequestRole, value: boolean) => {
        if (value) {
            setSelectedRoles([...selectedRoles, row.id]);
            return;
        }
        setSelectedRoles(selectedRoles.filter((id) => id !== row.id));
    };
    const handleSelectAll = (value: boolean) => {
        if (!value) {
            setSelectedRoles([]);
            return;
        }
        setSelectedRoles(roles.map((role) => role.id));
    };

    return (
        <CommonTable
            className="add-role-to-request-dialog-table"
            rows={roles as object[]}
            columns={columns as object[]}
            toolbarActions={toolbarActions}
            showPagination={false}
            showFiltersActions={false}
            getCellValue={getCellValue}
            createRowCellContent={createRowCellContent}
            onRowClick={() => {}}
            onSelectAll={handleSelectAll}
            onSelectRow={handleSelectRow}
            selectedIds={selectedRoles}
            setFilterData={() => {}}
            useKeyboardNavigation={false}
            toolbar={[]}
        />
    );
};

export default AddRoleToRequestDialogTable;
